import React from "react";
import { Box, Typography, Grid, Divider, Menu, MenuItem } from "@mui/material";

import { getkCal } from "../../../../components/LibraryFunctions";
import useWaterUnit from "../../../../hooks/useWaterUnit";

import MoreVertIcon from "@mui/icons-material/MoreVert";

import { rgba } from "polished";

const macroWidth = 100;
const menuColWidth = 40;

const activeStyle = {
  backgroundColor: rgba(0, 128, 0, 0.1),
  padding: 8,
  borderRadius: 8,
  color: "black",
  fontWeight: "600",
};

const inactiveStyle = {
  padding: 8,
  fontWeight: "600",
};

export default React.memo(({ nutritionGoal, onActivate, onEdit, onDelete }) => {
  const { waterLabel } = useWaterUnit();
  const kCals = React.useMemo(() => {
    return getkCal(nutritionGoal);
  }, [nutritionGoal]);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      type: "menu",
      menuName: "Set Goal as Active",
      menuFunction: () => {
        if (onActivate) {
          onActivate(nutritionGoal);
        }
      },
    },
    {
      type: "menu",
      menuName: "Edit Nutrition Goal",
      menuFunction: () => {
        if (onEdit) {
          onEdit(nutritionGoal);
        }
      },
    },
    {
      type: "menu",
      menuName: "Delete Nutrition Goal",
      menuFunction: () => {
        if (onDelete) {
          onDelete(nutritionGoal);
        }
      },
    },
  ];

  return (
    <Box>
      <Box style={nutritionGoal.active ? activeStyle : inactiveStyle}>
        <Grid
          container
          wrap="nowrap"
          alignItems="center"
          columnSpacing={1}
          sx={{ flexWrap: "nowrap", overflowX: "auto" }}
        >
          <Grid
            item
            sx={{
              flex: "1 1 auto",
              minWidth: 200,
            }}
          >
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: "bold",
                m: 0,
                minWidth: 0,
              }}
              title={nutritionGoal.name}
            >
              {nutritionGoal.name}
            </Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}
            >{`${
              nutritionGoal.proteins ? nutritionGoal.proteins.toFixed(0) : "0"
            } g`}</Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}
            >{`${
              nutritionGoal.carbs ? nutritionGoal.carbs.toFixed(0) : "0"
            } g`}</Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}
            >{`${
              nutritionGoal.fats ? nutritionGoal.fats.toFixed(0) : "0"
            } g`}</Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}
            >{`${kCals}`}</Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}
            >{waterLabel(nutritionGoal.water || 0)}</Typography>
          </Grid>

          <Grid
            item
            textAlign="center"
            sx={{ width: macroWidth, flexShrink: 0 }}
          >
            <Typography
              style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}
            >{`${
              nutritionGoal.fiber != null && nutritionGoal.fiber > 0
                ? `${Number(nutritionGoal.fiber).toFixed(1)} g`
                : "—"
            }`}</Typography>
          </Grid>

          <Grid
            item
            sx={{
              width: menuColWidth,
              minWidth: menuColWidth,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MoreVertIcon
              onClick={handleClick}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems &&
          menuItems.map((menuItem, index) => {
            if (menuItem.type === "menu") {
              return (
                <MenuItem
                  key={menuItem.menuName}
                  onClick={() => {
                    setAnchorEl(null);
                    if (menuItem.menuFunction) {
                      menuItem.menuFunction(nutritionGoal);
                    }
                  }}
                >
                  {`${menuItem.menuName}`}
                </MenuItem>
              );
            } else {
              return <Divider key={index} />;
            }
          })}
      </Menu>
    </Box>
  );
});
